module.exports = __webpack_public_path__ + "img/pwa-role-select-hen.9512f69c.png";